import { get } from "../../../utils/object-helpers";

$ {
    const text = get(input, "text", null);
    const image = get(input, "image", null);
}

<if(text && image)>
    $ {
        const variant = !!input.isSmall ? "modal" : "_mini";
        delete text.action;
        const pointer = get(input, 'pointer', 'bottom');
    }
    <span class="str-eek-tire">
        <str-textual-display ...text class="str-eek-tire__text" />
        <ebay-infotip variant=variant pointer=pointer>
            <@content>
                <str-image ...image loading="lazy" />
            </@content>
        </ebay-infotip>
    </span>
</if>
